import { useButton } from '@react-aria/button'
import cx from 'classnames'
import { mergeProps } from '@react-aria/utils'
import { useFocusRing } from '@react-aria/focus'
import { useRef } from 'react'
import { useModals } from 'almanac-ui/Modal'
import Styles from './CloseButton.module.scss'
import { Close } from 'blaze-ui/icons/16'

export const CloseButton = () => {
  const { closeModal } = useModals()
  const ref = useRef<HTMLButtonElement>(null)
  const { buttonProps, isPressed } = useButton({ onPress: closeModal }, ref)
  const { isFocusVisible, focusProps } = useFocusRing()

  return (
    <div className={Styles.closeButtonWrapper}>
      <button
        className={cx(Styles.closeButton, {
          [Styles.pressed]: isPressed,
          [Styles.focused]: isFocusVisible,
        })}
        ref={ref}
        {...mergeProps(buttonProps, focusProps)}
      >
        <Close />
      </button>
    </div>
  )
}
